"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import DialogConfirmation from "./DialogConfirmation";
import { useState } from "react";
import TextInput from "../commons/TextInput";
import TextAreaInput from "../commons/TextAreaInput";
import { addReview } from "../../firebase/sales";

export default function DialogReview({
    open,
    onClose,
    onCloseReceipt,
    item,
    reviewer
}) {
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [rating, setRating] = useState(0)
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')

    const handleSubmit = async () => {
        await addReview({ saleId: item.id, title, description, rating, reviewer })
        setShowConfirmModal(true)
        onCloseReceipt()
        onClose()
    }

    return (
        <>
            <DialogConfirmation
                message="Your review has been submitted successfully!"
                open={showConfirmModal}
                onClose={() => setShowConfirmModal(false)}
                buttonText="Done"
                title="Review Completed"
                iconSrc="/assets/icons/icon-check-circle.svg"
                type="confirm"
            />

            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden border-[1px] border-gray bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-[600px]"
                        >
                            <div className="w-full relative pt-9 pb-6 sm:px-6 px-2">
                                <div className="text-primary text-[24px] font-aero uppercase">
                                    Leave Review
                                </div>

                                <button onClick={onClose} className="absolute right-4 top-4">
                                    <img src="/assets/icons/icon-close-white.svg" alt="close" />
                                </button>

                                <div className="mt-6 text-sm text-white ">
                                    <div className="mb-2">
                                        Select Stars
                                    </div>

                                    <div className="-ml-1">
                                        {[1, 2, 3, 4, 5].map(item =>
                                            <button onClick={() => setRating(item)} key={`rating-${item}`}>
                                                {
                                                    item > rating ?
                                                        <img src="/assets/icons/icon-review-white-star.svg" alt="star" /> :
                                                        <img src="/assets/icons/icon-review-primary-star.svg" alt="star" />
                                                }
                                            </button>
                                        )}
                                    </div>

                                    <div className="mt-4">
                                        Review Title
                                    </div>

                                    <div className="mt-4">
                                        <TextInput
                                            value={title}
                                            placeholder="Titles"
                                            inputClassName="placeholder:text-white/60"
                                            divClassName="group focus-within:border-[#1AB6F9] transition"
                                            onChange={(v) => setTitle(v)}
                                        />
                                    </div>

                                    <div className="mt-4">
                                        Description
                                    </div>

                                    <div className="mt-4">
                                        <TextAreaInput
                                            placeholder="Write a detailed description.."
                                            textAreaClassName="placeholder:text-white/60 h-[150px]"
                                            onChange={(v) => setDescription(v)}
                                            divClassName="border-[1px] border-gray text-xs rounded-[6px] group focus-within:border-[#1AB6F9] transition"
                                        />
                                    </div>
                                </div>

                                <button
                                    className={`mt-4 bg-primary text-white text-xs w-[200px] h-[44px] flex justify-center items-center ${rating === 0 || title === '' || description === '' ? 'opacity-50' : ''}`}
                                    disabled={rating === 0 || title === '' || description === ''}
                                    onClick={handleSubmit}
                                >
                                    Submit Review
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
